module.exports = __webpack_public_path__ + "media/images/products/retailers-ecommerce-6-portal-78ea0f64b77f378a257457a42f27da58.jpg";